import React from 'react';

import AutoCardDetails from 'components/AutoDetails/components/AutoCardDetails';
import { Requester, TravelDetailsVehicle } from 'models/travelDetails';

import Driver from './components/Driver';
import { mapDetailsToVehicle } from './mapper';
import { SectionContainer } from './styles';

interface Props {
  auto: TravelDetailsVehicle;
  confirmationCode: string | number;
  requester: Requester;
}

const AutoDetailsSection = ({ auto, requester }: Props) => (
  <SectionContainer>
    <AutoCardDetails data={mapDetailsToVehicle(auto)} hasPickUpOptions={false} hasDropOffOptions={false} />
    <Driver requester={requester} />
  </SectionContainer>
);

export default AutoDetailsSection;
